@if ((isMobile$ | async) && (isAuthenticated$ | async)) {
  <ds-user-menu [inExpandableNavbar]="true"></ds-user-menu>
}
<div class="navbar-nav h-100 align-items-md-stretch gapx-3" role="menubar" id="main-site-navigation" [ngClass]="(isMobile$ | async) ? 'navbar-nav-mobile' : 'navbar-nav-desktop'">
  @for (section of (sections | async); track section) {
    <ng-container
    *ngComponentOutlet="(sectionMap$ | async).get(section.id)?.component; injector: (sectionMap$ | async).get(section.id)?.injector;"></ng-container>
  }
</div>
